import React, { Component } from 'react'
import { Button, Modal, Radio, Spin } from 'antd'
import { MANUAL_ASSIGN_TEXT, candidateDetail, candidateLabel } from '../utils'

// Manual user assignment V1: pick ONE of the row's instrument candidates. Presentational only --
// the queue owns the state, the request and the reload. There is deliberately no free search:
// the server accepts nothing outside the candidate set it recomputes on submit.
//
// PRIVACY: a candidate is { user_id, user_name, support_rows, via } and nothing else reaches
// here, so no card, bank or identity value can be rendered.
const SECOND_LINE = { display: 'block', fontSize: '0.75rem', color: '#8c8c8c', marginRight: 24 }

export default class AssignUserModal extends Component<any, any> {
    render() {
        const { row, loading, candidates, selected, submitting, onSelect, onCancel, onConfirm } = this.props
        const list = candidates || []

        return (
            <Modal
                visible={!!row}
                title="שיוך לקוח"
                onCancel={submitting ? undefined : onCancel}
                maskClosable={!submitting}
                closable={!submitting}
                footer={[
                    <Button key="cancel" onClick={onCancel} disabled={submitting}>
                        ביטול
                    </Button>,
                    <Button
                        key="confirm"
                        type="primary"
                        onClick={onConfirm}
                        disabled={loading || !selected || submitting}
                        loading={submitting}
                    >
                        אשר שיוך
                    </Button>
                ]}
            >
                <div style={{ marginBottom: 8, fontWeight: 500 }}>מועמדים שנמצאו</div>
                {loading ? (
                    <Spin />
                ) : list.length === 0 ? (
                    <span style={{ color: '#8c8c8c' }}>{MANUAL_ASSIGN_TEXT.empty}</span>
                ) : (
                    <Radio.Group
                        value={selected}
                        disabled={submitting}
                        onChange={event => onSelect(event.target.value)}
                        style={{ display: 'block' }}
                    >
                        {list.map(candidate => (
                            <Radio
                                key={candidate.user_id}
                                value={candidate.user_id}
                                style={{ display: 'block', marginBottom: 8 }}
                            >
                                <span>{candidateLabel(candidate)}</span>
                                <span style={SECOND_LINE}>{candidateDetail(candidate)}</span>
                            </Radio>
                        ))}
                    </Radio.Group>
                )}
            </Modal>
        )
    }
}
